import React, { useEffect, useState, useMemo } from "react";
import { InstallationType,LatoInstallation } from "../components/forms/Pergola_type";
import { ChiusuraChoice } from "../components/side/chiusure_choice";
import { LatoSide } from "../../../../../models/pergola_configuration";
import { useStoreSelector } from "../../../../../../hooks/StoreHooks";
import { SideSelector } from "../components/side/side_selector";

type MainSide = "back" | "front" | "left" | "right";

const LATO_LABELS = {
  front: "Fronte",
  back: "Retro",
  left: "Sinistra",
  right: "Destra",
} as const;

interface SideConfig {
  main: MainSide;
  label: string;
  subCount: number;
  subPrefix: string;
}

const SideChoices: React.FC = () => {
  const [mainSide, setMainSide] = useState<MainSide>("front");
  const [subSide, setSubSide] = useState<string | null>(null);
  const pergolaConfiguration = useStoreSelector((store) => store.pergolaConfigurationBuilder);

  const addossamento = useStoreSelector(
    (store) => store.pergolaConfigurationBuilder.configuration?.dimensioni.installazione
  );
  const lato = useStoreSelector(
    (store) => store.pergolaConfigurationBuilder.configuration?.dimensioni.lati
  );
  console.log("LAti",lato)
  useEffect(() => {
    if (addossamento === InstallationType.patio) {
      setMainSide("left");
    }
  }, [addossamento]);
  const larghezzaSoletta = (pergolaConfiguration.configuration?.dimensioni.larghezza ?? 2000) / 1000;
  const lunghezzaSoletta = (pergolaConfiguration.configuration?.dimensioni.profondita ?? 4000) / 1000;
  let nstacchi = Math.floor(larghezzaSoletta / 4.1);
  const tolleranza = 1e-9;

  if (Math.abs(nstacchi * 4.1 - larghezzaSoletta) > tolleranza) {
      nstacchi += 1;
  }
  let nstacchiy = Math.floor(lunghezzaSoletta / 7) ;
  if (Math.abs(nstacchiy * 7 - lunghezzaSoletta) > tolleranza) {
      nstacchiy += 1;
  }

  const sideConfigs: SideConfig[] = useMemo(() => {
    const configs: SideConfig[] = [];

    const isAddossato = (direzione: LatoSide["direzione"]) =>
      lato?.some(
        (l) => l.direzione === direzione && l.tipo === LatoInstallation.addossato
      );
    if (!isAddossato("Fronte")) {
      configs.push({ main: "front", label: "A", subCount: nstacchi, subPrefix: "A" });
    }

    if (!isAddossato("Sinistra")) {
      configs.push({ main: "left", label: "B", subCount: nstacchiy, subPrefix: "B" });
    }

    if (!isAddossato("Retro")) {
      configs.push({ main: "back", label: "C", subCount: nstacchi, subPrefix: "C" });
    }

    if (!isAddossato("Destra")) {
      configs.push({ main: "right", label: "D", subCount: nstacchiy, subPrefix: "D" });
    }

    return configs;
  }, [lato, nstacchi, nstacchiy]);

  useEffect(() => {
    const available = sideConfigs.map((c) => c.main);
    if (!available.includes(mainSide) && available.length > 0) {
      setMainSide(available[0]);
      setSubSide(null);
    }
  }, [sideConfigs, mainSide]);

  useEffect(() => {
    const config = sideConfigs.find((c) => c.main === mainSide);
    if (!config) return;

    if (config.subCount === 1) {
      setSubSide(null);
      return;
    }

    const valid = Array.from({ length: config.subCount }, (_, i) => `${config.subPrefix}${i + 1}`);
    if (!subSide || !valid.includes(subSide)) {
      setSubSide(valid[0]);
    }
  }, [mainSide, sideConfigs, subSide]);

  const currentConfig = sideConfigs.find((c) => c.main === mainSide);
  const hasSubTabs = currentConfig && currentConfig.subCount > 1;

  // === SEGMENTO: SEMPRE number ===
  const segmento: number = subSide
    ? parseInt(subSide.replace(/\D/g, ""), 10)
    : currentConfig?.subCount || 1;
  const latoLabel = mainSide ? LATO_LABELS[mainSide] : "Fronte";

  return (
    <div>
      <SideSelector
        sides={sideConfigs.map((config) => config.main)}
        value={mainSide}
        onChange={setMainSide}
      />

      <div style={{ marginTop: 20 }}>
        {hasSubTabs && currentConfig && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
            {Array.from({ length: currentConfig.subCount }, (_, i) => {
              const label = `${currentConfig.subPrefix}${i + 1}`;
              const selected = label === subSide;
              return (
                <button
                  key={label}
                  type="button"
                  onClick={() => setSubSide(label)}
                  style={{
                    minWidth: 52,
                    padding: "6px 14px",
                    borderRadius: 8,
                    border: `1px solid ${selected ? "var(--bs-primary, #ff5a1f)" : "#e0e0e0"}`,
                    background: selected ? "rgba(255, 90, 31, 0.08)" : "#fff",
                    boxShadow: selected ? "0 2px 8px rgba(0,0,0,0.12)" : "none",
                    color: selected ? "var(--bs-primary, #ff5a1f)" : "inherit",
                    fontWeight: selected ? 700 : 400,
                    cursor: "pointer",
                    transition: "0.2s",
                  }}
                >
                  {label}
                </button>
              );
            })}
          </div>
        )}
        {currentConfig && (
          <ChiusuraChoice
            lato={latoLabel}
            segmento={segmento}
          />
        )}
      </div>
    </div>
  );
};

export default SideChoices;
